import { ComposableCommerceEvents } from 'sdk/composable-commerce/types/events/ComposableCommerceEvents';
import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import {
  AmazonPaySignatureReturn,
  GetAmazonDataAction,
  GetAmazonCheckoutSessionDataAction,
  UpdateAmazonCheckoutSessionDataAction,
  UpdateAmazonCheckoutResponse,
  CompleteAmazonCheckout,
  CompleteAmazonCheckoutSessionDataAction,
} from 'sdk/composable-commerce/types/actions/AmazonActions';
import {
  AmazonPayPayload,
  CompleteAmazonPaymentPayload,
  UpdateAmazonCheckoutPayload,
} from 'sdk/composable-commerce/types/payloads/AmazonPayPayload';

export type AmazonActions = {
  getAmazonSignature: GetAmazonDataAction;
  getAmazonCheckoutSessionData: GetAmazonCheckoutSessionDataAction;
  updateAmazonCheckoutSession: UpdateAmazonCheckoutSessionDataAction;
  completeAmazonCheckout: CompleteAmazonCheckoutSessionDataAction;
};

export const getAmazonData = (sdk: SDK<ComposableCommerceEvents>): AmazonActions => {
  return {
    getAmazonSignature: async (payload: AmazonPayPayload) => {
      const response = await sdk.callAction<AmazonPaySignatureReturn>({
        actionName: 'amazon/getAmazonSiganture',
        payload,
      });
      return response;
    },
    getAmazonCheckoutSessionData: async (payload: string) => {
      const response = await sdk.callAction<AmazonPaySignatureReturn>({
        actionName: 'amazon/getAmazonCheckoutSession',
        payload,
      });
      return response;
    },
    updateAmazonCheckoutSession: async (payload: UpdateAmazonCheckoutPayload) => {
      const response = await sdk.callAction<UpdateAmazonCheckoutResponse>({
        actionName: 'amazon/updateAmazonCheckoutSession',
        payload,
      });
      return response;
    },
    completeAmazonCheckout: async (payload: CompleteAmazonPaymentPayload) => {
      const response = await sdk.callAction<CompleteAmazonCheckout>({
        actionName: 'amazon/completeAmazonCheckout',
        payload,
      });
      return response;
    },
  };
};
